module.exports = __webpack_public_path__ + "img/cuento.414395fc.png";